
export function updateRuleValue(rule: any, isNamedParameter: boolean): string[] {
    let ruleVal: string[] = [];
    let namedParameters: string[] = [];
    ruleVal = updateValue(rule, isNamedParameter, [], ruleVal, namedParameters);
    return ruleVal;
  }
  
  export function getParameterSql(content: string, ruleValue: any): string {
    let replacedString: string = content.replace(/[%']/g, "");
    return '{ "sql": "(' + replacedString + ')", "params": [' + ruleValue.join(", ") + '] }';
    
  }
  
  export function getNamedParameterSql(content: string, ruleValue: any): string {
    let replacedString: string = content.replace(/[%']/g, "");
    return '{ "sql": "(' + replacedString + ')", "params": {' + ruleValue.join(", ") + '} }';
  }
  
  const updateValue = function(rule: any, isNamedParameter: boolean, list: any, ruleVal: string[], namedParameters: string[]): string[] {
    if(Object.keys(rule).length == 0 && rule.rules == undefined)
    {
        return ruleVal;
    }
    let qbrules: any = rule.rules;
    let namedField: string | null = null; 
    for (let i: number = 0; i < qbrules.length; i++) {
        list.push(qbrules[i]);
    }
    let rulecollection: any = list; 
    let len: number = rulecollection.length; 
    for (let i: number = 0; i < len; i++) {
        if (rulecollection[i].rules != null) { 
            let rule: any = rulecollection[i];
            list = [];
            rulecollection = []; 
            ruleVal = updateValue(rule, isNamedParameter, list, ruleVal, namedParameters);
        } else {
            if (rulecollection[i].value instanceof Array) {
                for (let j: number = 0; j < (rulecollection[i].value as any).length; j++) {
                    if (isNamedParameter) {
                        namedField = getNamedParameter(rulecollection[i].field, namedParameters);
                    }
                    if (rulecollection[i].type === "string" || rulecollection[i].type === "date") {
                        if (isNamedParameter) {
                            const newValue: string = '"' + namedField + '": ' + '"' + rulecollection[i].value[j].toString() + '"';
                            ruleVal.push(newValue);
                        } else {
                            ruleVal.push('"' + rulecollection[i].value[j].toString() + '"');
                        }
                    } else {
                        if (isNamedParameter) {
                            const newValue: string = '"' + namedField + '": ' + rulecollection[i].value[j].toString();
                            ruleVal.push(newValue);
                        } else {
                            ruleVal.push(rulecollection[i].value[j].toString());
                        }
                    }
                    if (isNamedParameter) {
                        rulecollection[i].value[j] = ":" + namedField;
                    } else {
                        rulecollection[i].value[j] = "?";
                    }
                }
            } else {
                if (isNamedParameter) {
                  namedField = getNamedParameter(rulecollection[i].field, namedParameters);
                }
                if (rulecollection[i].operator.indexOf('null') < 1) {
                    if (rulecollection[i].type != "string" || (rulecollection[i].type == "string" && rulecollection[i].value != "")) {
                        if (rulecollection[i].type === "string" || rulecollection[i].type === "date") {
                            if (rulecollection[i].operator.indexOf('empty') < 1) {
                              let value: string = rulecollection[i].value.toString();
                              switch (rulecollection[i].operator) {
                                case 'startswith':
                                  value = value + '%';
                                  break;
                                case 'endswith':
                                  value = '%' + value;
                                  break;
                                case 'contains':
                                  value = '%' + value + '%';
                                  break;
                              }
                              if (isNamedParameter) {
                                const newValue: string = '"' + namedField + '": ' + '"' + value + '"';
                                ruleVal.push(newValue);
                              } else {
                                  ruleVal.push('"' + value + '"'); 
                              }
                            } else {
                                if (isNamedParameter) {
                                    const newValue: string = '"' + namedField + '": ' + '"' + '"';
                                    ruleVal.push(newValue);
                                } else {
                                    ruleVal.push('"' + '"'); 
                                }
                                if (rulecollection[i].operator === 'isempty') {
                                    rulecollection[i].operator = 'equal';
                                } else {
                                    rulecollection[i].operator = 'notequal';
                                }
                            }
                        } else {
                            if (isNamedParameter) {
                                const newValue: string = '"' + namedField + '":' + rulecollection[i].value.toString();
                                ruleVal.push(newValue);
                            } else {
                                ruleVal.push(rulecollection[i].value.toString());
                            }
                        }
                        if (isNamedParameter) {
                            rulecollection[i].value = ":" + namedField;
                        } else {
                            rulecollection[i].value = "?";
                        }
                    }
                }
            }
        }
    } 
    rulecollection = []; 
    list= [];
    return ruleVal;
  }
  
  function getNamedParameter(field: string, namedParameters: string[]): string {
    let newField: string | null = null;
    if (namedParameters.length > 0) {
        for (let i: number = namedParameters.length - 1; i >= 0; i--) {
            const currField: string  = namedParameters[i];
            if (currField.indexOf(field) > -1) {
                const regexMatch = currField.match(/_(\d+)$/);
                const idx: number = regexMatch ? parseInt(regexMatch[1], 10) + 1: 1;
                newField = field + '_' + idx;
                namedParameters.push(newField);
                break;
            }
        }
    }
    if (!newField) {
        newField = field + '_1';
        namedParameters.push(newField);
    }
    return newField;
  }